var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticStyle:{"max-width":"1800px"}},[_c('v-card',{staticClass:"ma-0"},[_c('v-toolbar',{attrs:{"color":"primary","dark":""}},[_vm._v(" Usuários "),_c('v-spacer')],1),_c('v-card-text')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }